import { css } from '@emotion/css';

export const SearchListEmptyStateContainerStyles = css`
  margin-top: 14.4rem;
`;

export const SearchListEmptyStateStyles = css`
  gap: 0.8rem;
  max-width: 36.4rem;
  white-space: pre-line;
`;
